window.__menuFixed = true;

function fixSubmenu(item) {
  const inner = item.querySelector('.menu-list__submenu-inner');
  const title = item.querySelector('.menu-list__link-title');
  if (!inner || !title) return;
  const titleLeft = Math.round(title.getBoundingClientRect().left);
  // 40px 是 mega-menu section grid 的固定左邊距
  const padding = titleLeft - 30;
  inner.style.setProperty('padding-inline-start', padding + 'px', 'important');
  inner.style.setProperty('width', 'max-content', 'important');
}

document.addEventListener('pointerenter', (e) => {
  if (!e.target || typeof e.target.closest !== 'function') return;
  const item = e.target.closest('.menu-list__list-item:not([slot="overflow"])');
  if (item) fixSubmenu(item);
}, true);
